/**
 * AI API Client - Backend-proxied AI services
 */

import apiClient from './client.js';
import type { ReferenceImage } from '../image/types';

export interface AIResponse {
    success: boolean;
    content: string;
    error?: string;
}

export interface ImageResponse {
    success: boolean;
    b64_json?: string;
    mime_type?: string;
    error?: string;
}

/**
 * Generate text using backend proxy
 */
export async function generateText(prompt: string, systemPrompt?: string, provider?: string): Promise<AIResponse | null> {
    try {
        const response = await apiClient.post<AIResponse>('/ai/generate-text', {
            prompt,
            systemPrompt,
            provider
        });
        return response?.data || null;
    } catch (error) {
        console.error('[AI] Text generation failed:', error);
        return null;
    }
}

/**
 * Generate image using backend proxy (placeholder for future use)
 */
export async function generateImage(
    prompt: string,
    _storyId?: string,
    aspectRatio?: string,
    referenceImages?: ReferenceImage[]
): Promise<ImageResponse | null> {
    try {
        const response = await apiClient.post<ImageResponse>('/ai/generate-image', {
            prompt,
            aspectRatio,
            referenceImages,
        });
        return response?.data || (response?.error ? { success: false, error: response.error } : null);
    } catch (error) {
        console.error('[AI] Image generation failed:', error);
        return null;
    }
}
